import type { ReactNode } from 'react'
import ErrorBoundary from 'components/Common/ErrorBoundary'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import OfferPageAssistantSurface from './OfferPageAssistantSurface'

interface Props {
  children: ReactNode
  offerPageState: OfferPageState
}

export default function OfferPageAssistantHost({ children, offerPageState }: Props) {
  return <>
    {children}
    <ErrorBoundary fallback={null}>
      <OfferPageAssistantSurface offerPageState={offerPageState} />
    </ErrorBoundary>
  </>
}
